import {
  type ClientApplicationContext,
  getClientApplicationContext,
} from '@hc-frontend/core-context';
import type { ResponseSnowPlow } from '@hc-frontend/third-party-snowplow';

import { snowplowTrackingRepositoryAdapterFactory } from '../../../adapters/snowplow-tracking-repository';
import { getDomainIdsFactory } from '../../../domain';

export function getSessionIdClientSide(
  tracker: ResponseSnowPlow['tracker'],
): ClientApplicationContext['getDomainSessionId'] {
  return async () => {
    const context = getClientApplicationContext(getSessionIdClientSide);
    const useCase = getDomainIdsFactory({
      ...context,
      sessionProvider: snowplowTrackingRepositoryAdapterFactory(tracker),
    });

    const result = await useCase();

    return result.data.sessionId || '';
  };
}
